import * as api from 'js/common/services/api';

const SET_DB_USERS = 'dbUsers/SET_DB_USERS';

const initialState = {};

// Reducer

// eslint-disable-next-line no-multi-assign
export default function dbUsersReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DB_USERS: {
      return {
        ...state,
        dbUsers: action.payload,
      };
    }
    default:
      return state;
  }
}

const getDbUsersData = (state) => state.nds.dbUsers;

// Selectors
export const getDbUsers = (state) => getDbUsersData(state).dbUsers;

export const loadDbUsers = (groupId) => async (dispatch) => {
  const response = await api.nds.users.getUsers(groupId);

  dispatch({
    type: SET_DB_USERS,
    payload: response,
  });

  return response;
};
